import React, { useEffect, useState } from "react";
import { Helmet } from "react-helmet";
import { useNavigate } from 'react-router-dom';
import { Box, Grid, Card, Container, Typography, useTheme } from "@mui/material";
import { tokens } from "../../theme";
import GridToSettingPlant from '../../components/grid/GridToSettingPlant'
import Factory from '../../assets/img/factory1.png'
import MasterFooter from "../../components/setting/MasterFooter"

const setting_1 = [
    {
        title: '1',
        detail: 'Setting master std in factory 1',
        icon: <img src={Factory} height="60vh" />,
        click: 'list-master-std'
    }
]

const setting_4045 = [
    {
        title: '00000000000001',
        detail: 'Setting master std in factory 00000000000001',
        icon: <img src={Factory} height="60vh" />,
        click: 'list-master-std'
    }
]

const setting_4071 = [
    {
        title: 'FPP1',
        detail: 'Setting master std in factory FPP1',
        icon: <img src={Factory} height="60vh" />,
        click: 'list-master-std'
    }
]

const setting_4116 = [
    {
        title: 'PlantB',
        detail: 'Setting master std in factory PlantB',
        icon: <img src={Factory} height="60vh" />,
        click: 'list-master-std'
    }
]

const setting_4117 = [
    {
        title: 'FPP2',
        detail: 'Setting master std in factory FPP2',
        icon: <img src={Factory} height="60vh" />,
        click: 'list-master-std'
    }
]

const setting_4003 = [
    {
        title: 'FPP2',
        detail: 'Setting master std in factory FPP2',
        icon: <img src={Factory} height="60vh" />,
        click: 'list-master-std'
    }
]

const setting_4087 = [
    {
        title: 'FPP3',
        detail: 'Setting master std in factory FPP3',
        icon: <img src={Factory} height="60vh" />,
        click: 'list-master-std'
    }
]

const setting_4179 = [
    {
        title: '1',
        detail: 'Setting master std in factory 1',
        icon: <img src={Factory} height="60vh" />,
        click: 'list-master-std'
    }
]

export default function MasterSTDFactory() {
    const navigate = useNavigate();
    const theme = useTheme();
    const colors = tokens(theme.palette.mode);

    const storeCourse = (name) => {
        sessionStorage.setItem("master_std_factory", name);
    };

    const plant = sessionStorage.getItem("master_std_plant") || "";

    const settingByPlant = {
        "4117": setting_4117,
        "4116": setting_4116,
        "B425": setting_1,
        "4045": setting_4045,
        "4003": setting_4003,
        "4087": setting_4087,
        "4071": setting_4071,
        "4179": setting_4179,
    };

    const settingList = settingByPlant[plant] ?? setting_4071; // default เผื่อไม่เจอ
    

    return (
        <Box sx={{ width: "100%", height: "93.5vh", position: "relative", overflow: "hidden" }}>
            <Helmet>
                <title>STD Factory | MES</title>
            </Helmet>

            <Container maxWidth="md">
                <Grid item xs={12} textAlign="center" sx={{ pt: 1 }}>
                    <Typography sx={{ color: colors.neutral["black"], fontSize: 58, fontWeight: "bold" }}>
                        Factory
                    </Typography>
                </Grid>

                <Grid item xs={12} sx={{ pt: 4 }}>
                    <Grid container columnSpacing={0}>
                        {settingList.map((item) => (
                            <Grid
                                key={`${plant}-${item.title}`}   // ✅ ใส่ key ลด warning/bug
                                item
                                xs={9.5}
                                onClick={() => {
                                    storeCourse(item.title);
                                    navigate(`/${item.click}`, { replace: true });
                                }}
                            >
                                <GridToSettingPlant icon={item.icon} title={item.title} detail={item.detail} />
                            </Grid>
                        ))}
                    </Grid>
                </Grid>
            </Container>

            <Box sx={{ position: "absolute", bottom: 10, left: 10, zIndex: 10 }}>
                <MasterFooter click={"setting/master-std-plant"} />
            </Box>
        </Box>
    );
}